import { useState } from "react";
import SidePanel from "../components/SidePanel";
import TopRelatedFilter from "../components/TopRelatedFilter";

const GraphAnalysisPage = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [displayData, setDisplayData] = useState();
  const [isLoading] = useState(false); // kept for prop compatibility if you want

  return (
    <div className="flex relative">
      <SidePanel
        collapseCallback={() => setCollapsed(!collapsed)}
        collapsed={collapsed}
        data={displayData}
      />

      <div className="grow">
        <div className="p-6 pb-0">
          <h1 className="mb-6 text-center">Graph Analysis</h1>

          <div className="w-full flex flex-col items-center content-center overflow-y-auto custom-scrollbar h-[83vh]">
            <TopRelatedFilter
              propagnateData={(value) => setDisplayData(value)}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraphAnalysisPage;